// extracted by mini-css-extract-plugin
export default {"container":"category_container__+pBOH","header":"category_header__sKEvn","category":"category_category__rxpBF"};